import { HeroSectionCity } from "@/components/heros/section-hero-city";
import { AboutSection } from "@/components/sections/section-about";
import { AboutTransportSection } from "@/components/sections/section-about-transporte";
import { BannerSection } from "@/components/sections/section-banner";
import { CertificationSection } from "@/components/sections/section-certification";
import { HowWorkSection } from "@/components/sections/section-how-work";
import { JourneySection } from "@/components/sections/section-journey";
import { useUtmParameters } from "@/hooks/useUtmParameters";

import { StatsSection } from "@/components/sections/section-stats";
import { TestimonialSection } from "@/components/sections/section-testimonial";
import { TransportSection } from "@/components/sections/section-transport";
import { WhoSection } from "@/components/sections/section-who";
import { WhySection } from "@/components/sections/section-why-section";

const TransportePage = () => {
  useUtmParameters();

  const city = "sua cidade";
  const state = "seu estado";
  return (
    <div className="bg-n-bg-1">
      {/* Hero Section */}
      <HeroSectionCity cityName={city} />

      {/* About Transport Section */}
      <AboutTransportSection cityName={city} stateName={state} />

      {/* How It Works Section - Como funciona*/}
      <HowWorkSection cityName={city} />

      {/* Jornada do usuário */}
      <JourneySection stateName={state} />

      {/* Seção do tipos de transporte */}
      <TransportSection />

      {/* for who section */}
      <WhoSection />

      {/* Why nacional go */}
      <WhySection />

      {/* Stats Section */}
      <StatsSection />

      {/* Testimonial section */}
      <TestimonialSection />

      {/* Certification section */}
      <CertificationSection />

      {/* About */}
      <AboutSection />

      {/* Banner de cotação */}
      <BannerSection />
    </div>
  );
};

export default TransportePage;
